import LoyaltyProgramTemplate from "../../templates/LoyaltyProgramServiceTemplate/LoyaltyProgramTemplate";

const LoyaltyProgramPage = () => {
  return <LoyaltyProgramTemplate />;
};

export default LoyaltyProgramPage;
